module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": ("Disconnect your " + (_vm.integration.name) + " account?"),
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('main', {
    staticClass: "flex flex-grow center items-center p-5"
  }, [_c('div', {
    staticClass: "flex center items-center",
    staticStyle: {
      "flex-direction": "column",
      "font-size": "16px"
    }
  }, [(_vm.getProfile.role === 'teacher') ? _c('span', [_vm._v("\n        This action will disconnect your current connected\n        " + _vm._s(_vm.integration.name) + " account from your Parlay Courses. If you want\n        to share roster / assignment / assessment data between\n        " + _vm._s(_vm.integration.name) + " and Parlay in the future, you will have to\n        reconnect your account.\n      ")]) : _c('span', [_vm._v("\n        This action will disconnect your current connected\n        " + _vm._s(_vm.integration.name) + " account from your Parlay Courses. If your\n        teacher connects your Parlay class to a " + _vm._s(_vm.integration.name) + " class\n        in the future, you will have to reconnect your account.\n      ")]), _vm._v(" "), (_vm.loading) ? _c('pl-spinner') : _c('span', {
    staticClass: "my-3 font-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.profile.email) + "\n      ")])], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "flex center items-center my-5"
  }, [_c('button', {
    staticClass: "mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "mx-5 px-10 py-2 w-40 bg-red-300 hover:bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.disconnectAccount
    }
  }, [_vm._v("\n      Disconnect\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cce2cf0c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/profileDisconnectIntegrationModal.vue
// module id = 1631
// module chunks = 61